/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityStatsVulnerabilityCategoriesCount } from './MonitEntityStatsVulnerabilityCategoriesCount';
import {
    MonitEntityStatsVulnerabilityCategoriesCountFromJSON,
    MonitEntityStatsVulnerabilityCategoriesCountFromJSONTyped,
    MonitEntityStatsVulnerabilityCategoriesCountToJSON,
} from './MonitEntityStatsVulnerabilityCategoriesCount';

/**
 * 
 * @export
 * @interface MonitEntityStatsVulnerabilityCategories
 */
export interface MonitEntityStatsVulnerabilityCategories {
    /**
     * 
     * @type {MonitEntityStatsVulnerabilityCategoriesCount}
     * @memberof MonitEntityStatsVulnerabilityCategories
     */
    categories?: MonitEntityStatsVulnerabilityCategoriesCount;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MonitEntityStatsVulnerabilityCategories
     */
    score_categories?: { [key: string]: any; };
}

/**
 * Check if a given object implements the MonitEntityStatsVulnerabilityCategories interface.
 */
export function instanceOfMonitEntityStatsVulnerabilityCategories(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityStatsVulnerabilityCategoriesFromJSON(json: any): MonitEntityStatsVulnerabilityCategories {
    return MonitEntityStatsVulnerabilityCategoriesFromJSONTyped(json, false);
}

export function MonitEntityStatsVulnerabilityCategoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityStatsVulnerabilityCategories {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categories': !exists(json, 'categories') ? undefined : MonitEntityStatsVulnerabilityCategoriesCountFromJSON(json['categories']),
        'score_categories': !exists(json, 'score_categories') ? undefined : json['score_categories'],
    };
}

export function MonitEntityStatsVulnerabilityCategoriesToJSON(value?: MonitEntityStatsVulnerabilityCategories | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categories': MonitEntityStatsVulnerabilityCategoriesCountToJSON(value.categories),
        'score_categories': value.score_categories,
    };
}

